import React from 'react';
import Hero from '../components/Home/Hero';
import Highlights from '../components/Home/Highlights';
import Footer from '../components/Footer';

function Home() {
  return (
    <div>
      <Hero />
      <Highlights />
      <Footer />
    </div>
  )
}

export default Home
